import { EnvEnum, EnvType } from "../types";
import {
  allowedMimeTypes,
  maxFileSizeInMB,
  fileSizeConversionRate,
} from "./contants";

export const getDomain = () => {
  const ENVIRONMENT: EnvType = process.env.REACT_APP_ENVIRONMENT as EnvType;
  if(ENVIRONMENT === EnvEnum.TEST) return "blakesshawn";

  const hostname = window.location.hostname;
  const domain = hostname.split(".");
  return domain[0];
};

export const validateInput = (val: any, next: () => any) => {
  if (isNaN(val)) return;
  next();
};

export const checkIsValidHTML = (content: string):boolean => {
  return /<\/?[a-z][\s\S]*>/i.test(content)
};

const fieldValues = [
  {
    label: "Date Created",
    key: "create_time",
  },

  {
    label: "Summary",
    key: "summary",
  },

  {
    label: "Description",
    key: "description",
  },

  {
    label: "Customer Name",
    key: "customer_name",
  },

  {
    label: "Phone",
    key: "contact_number",
  },

  {
    label: "Category",
    key: "customer_category",
  },

  {
    label: "Queue",
    key: "queue_name",
  },

  {
    label: "Queue Type",
    key: "queue_type_name",
  },
];

export const formatTicketDetails = (
  data: Record<string, any>
): { label: string; value: string }[] => {
  const fields: any[] = [];

  data &&
    fieldValues.map((item) => {
      const newObj = { label: item.label, value: trimIfString(data[item.key]) };

      fields.push(newObj);
    });

  return fields;
};

const trimIfString = (value: any) => {
  if (typeof value === "string") {
    return value.trim();
  }
  return value;
};

export const isImage = (url: string) => {
  return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
};

export const allowFileAttachment = (file: File): boolean => {
  if (
    allowedMimeTypes.includes(file.type) &&
    Number(file.size) <= maxFileSizeInMB * Math.pow(fileSizeConversionRate, 2)
  )
    return true;
  else return false;
};
